import React, { useEffect, useState } from 'react';
import {
  arrayOf, shape, string,
} from 'prop-types';
import * as S from './styles';

const ClickMap = (props) => {
  const { data, imageSrc, id } = props;
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

  const points = data.map((result) => ({
    x: parseInt(result.firstClickCoordinates.x, 10),
    y: parseInt(result.firstClickCoordinates.y, 10),
  }));

  useEffect(() => {
    const img = new Image();
    img.src = imageSrc;
    img.onload = (i) => {
      const { width, height } = i.target;
      setImageDimensions({ width, height });
      setImageLoaded(true);
    };
  }, [imageSrc]);

  return (
    <>
      {!imageLoaded ? (
        <S.Centered>
          <S.Loader data-loader="clickMap-loader" />
        </S.Centered>
      ) : (
        <S.Container>
          <S.BaseImage id={`clickMap-${id}`} src={imageSrc} alt="clickMap" isBrightness />
          {points.map((point) => {
            const leftPercent = (point.x / imageDimensions.width) * 100;
            const topPercent = (point.y / imageDimensions.height) * 100;
            return (
              <S.BallDim
                key={`${id}-${point.x}-${point.y}`}
                style={{
                  left: `${leftPercent}%`,
                  top: `${topPercent}%`,
                  transform: 'translate(-50%, -50%)',
                }}
              />
            );
          })}
        </S.Container>
      )}
    </>
  );
};

ClickMap.propTypes = {
  data: arrayOf(
    shape({
      firstClickCoordinates: shape({
        x: string.isRequired,
        y: string.isRequired,
      }).isRequired,
    }),
  ).isRequired,
  imageSrc: string.isRequired,
  id: string.isRequired,
};

ClickMap.defaultProps = {};

export default ClickMap;
